import * as React from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faExclamationTriangle} from '@fortawesome/free-solid-svg-icons'

import * as style from './error-alert.module.scss'

type Props = {
  children: React.ReactNode
}

export default function ErrorAlert(props: Props): React.ReactElement {
  const {children} = props
  return (
    <div className="p-3 bg-[#ff7f00] border border-chrome rounded mb-5">
      <div className={style.errorAlert}>
        <FontAwesomeIcon icon={faExclamationTriangle} size="3x" aria-hidden="true" />
        <div>{children}</div>
      </div>
    </div>
  )
}
